import { Col, Container, Row } from 'react-bootstrap'
import { KeepGoing } from 'src/component/lets-get-moving/keep-going'
import { SuggestedSeries } from 'src/component/lets-get-moving/suggested-series'
import { SuggestedWorkouts } from 'src/component/lets-get-moving/suggested-workouts'
import { SectionTitle } from 'src/component/ui/section-title'

export const LetsGetMoving = (): React.ReactElement => {
  return (
    <Container className="mt-20 bg-black w-full pb-20">
      <Row className="flex justify-between items-center mb-10">
        <SectionTitle>Let's get moving</SectionTitle>
      </Row>
      <Row className="mb-10 lg:mb-12">
        <Col xs={12}>
          <SuggestedSeries />
        </Col>
      </Row>
      <Row className="mb-10 lg:mb-12">
        <Col xs={12}>
          <KeepGoing />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <SuggestedWorkouts />
        </Col>
      </Row>
    </Container>
  )
}
